export default __webpack_public_path__ + "static/media/whiffle-ball.6be58780.svg";